export default "__VITE_ASSET__Cd_OVcxe__"